import React from 'react'
import './index.scss'

class Card extends React.Component {
  constructor(props) {
    super(props)
    this.handleMouseMove = this.handleMouseMove.bind(this)
    this.handleMouseOut = this.handleMouseOut.bind(this)
    this.handleMouseEnter = this.handleMouseEnter.bind(this)
    this.state = { x: 0, y: 0 }
  }

  handleMouseMove(event) {
    var x = Math.round((event.clientX - this.state.left - (this.state.width / 2)) /-8, 0);
    var y = Math.round((event.clientY - this.state.top + this.state.scrollTop - (this.state.height / 2)) / 8, 0);

    this.setState({
      styles: {
        transform: `perspective(${this.state.width}px) scale(1.1) rotateY(${x}deg) rotateX(${y}deg)`,
        willChange: `transform`,
      },
    })
  }

  handleMouseOut(event) {
    this.setState({
      styles: {
        transform: `none`,
        willChange: `auto`,
      },
    })
  }

  handleMouseEnter() {
    var scrollTop = window.pageYOffset !== undefined ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop
    
    this.setState({
      scrollTop: scrollTop,
      styles: {
        willChange: `transform`,
      },
    })
  }

  updateBoundingClientRect() {
    var rect = this.node.getBoundingClientRect();
    this.setState({
      top: Math.round(rect.top, 0),
      left: Math.round(rect.left, 0),
      width: Math.round(rect.width, 0),
      height: Math.round(rect.height, 0),
    })
  }

  componentDidMount() {
    this.updateBoundingClientRect();
  }

  /**
   * Add event listener
   */
  componentDidMount() {
    this.updateBoundingClientRect()
    window.addEventListener('resize', this.updateBoundingClientRect.bind(this))
  }

  /**
   * Remove event listener
   */
  componentWillUnmount() {
    window.removeEventListener('resize', this.updateBoundingClientRect.bind(this))
  }

  render() {
    return (
      <div
        className="card"
        style={this.state.styles}
        onMouseMove={this.handleMouseMove}
        onMouseOut={this.handleMouseOut}
        onMouseEnter={this.handleMouseEnter}
        ref={node => this.node = node}
      >
        <img
          src={this.props.data.logo.publicURL}
          alt={this.fullName}
          height="70"
          width="70"
        />
      </div>
    )
  }
}

export default Card


// WEBPACK FOOTER //
// ./src/components/Card/index.js